/* eslint-disable no-param-reassign */
import { countryCodeFromGeoRegion } from './geo_regions';
import { PROGRAMMES_STUDIO_FEATURE_CODE } from './programmes';

export const userCountryCode = (userProfile) => {
  if (!userProfile) {
    return null;
  }
  const { countryCode } = userProfile;
  if (!countryCode) {
    return countryCodeFromGeoRegion(userProfile.geoRegion);
  }

  return countryCode;
};

export const userLocale = (userProfile) => {
  const countryCode = userCountryCode(userProfile);
  return countryCode === 'US' ? 'en-US' : 'en-GB';
};

export const userCurrencyCode = (userProfile) => {
  const countryCode = userCountryCode(userProfile);
  return countryCode === 'GB' ? 'GBP' : 'USD';
};

export const userIsCreator = (userProfile) => {
  if (!userProfile) {
    return null;
  }
  return (userProfile.enabledFeatures || []).includes(
    PROGRAMMES_STUDIO_FEATURE_CODE,
  );
};

export const userProfileWithIncrementedCounters = (userProfile, counters) => {
  if (!userProfile || !userProfile.activitySummary) {
    return userProfile;
  }
  const updatedUserProfile = {
    ...userProfile,
    activitySummary: { ...userProfile.activitySummary },
  };
  counters.forEach((counter) => {
    updatedUserProfile.activitySummary[counter] =
      (updatedUserProfile.activitySummary[counter] || 0) + 1;
  });
  return updatedUserProfile;
};

export const healthProGroupForSpaceID = (creatorSpaceID) =>
  creatorSpaceID && `space-admins-${creatorSpaceID}`;

// export const userPlannerViewWeekStartDay = (userProfile) => {
//   const startDay = userProfile?.plannerViewWeekStartDay;
//   return plannerViewWeekStartDayOrDefault(startDay);
// };

export const MINIMUM_PASSWORD_LENGTH = 8;

export const suggestedCustomerIngredientNamesLabel = (currentSpaceID) => {
  if (
    currentSpaceID === '48646413-d3fd-4808-bab5-c5a108cab03f' ||
    currentSpaceID === 'ae5a029f-d08e-447e-a818-cb342b97afb7'
  ) {
    // Wildbiome
    return 'Alternative Wild Ingredients';
  }
  return null;
};
